import React, { useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import classNames from "classnames";

export const MultipleContentScroll = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(1);
  var settings = {
    autoplay: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: false,
    // fade: true,
    beforeChange: (old, newIndex) => {
      console.log(old, newIndex);
      if (old === 3) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(newIndex + 1);
      }
    },
  };
  const ScrollCards = [
    {
      name: t("learn.mfaPage.features.blockOne.item1.title"),
      descript: t("learn.mfaPage.features.blockOne.item1.descript"),
      icon: "authing-user-3-fill",
      keyIndex: 0,
    },
    {
      name: t("learn.mfaPage.features.blockOne.item2.title"),
      descript: t("learn.mfaPage.features.blockOne.item2.descript"),
      icon: "authing-fingerprint-line",
      keyIndex: 1,
    },
    {
      name: t("learn.mfaPage.features.blockOne.item3.title"),
      descript: t("learn.mfaPage.features.blockOne.item3.descript"),
      icon: "authing-map-pin-2-fill",
      keyIndex: 2,
    },
    {
      name: t("learn.mfaPage.features.blockOne.item4.title"),
      descript: t("learn.mfaPage.features.blockOne.item4.descript"),
      icon: "authing-git-pull-request-line",
      keyIndex: 3,
    },
    {
      name: t("learn.mfaPage.features.blockOne.item5.title"),
      descript: t("learn.mfaPage.features.blockOne.item5.descript"),
      icon: "authing-bubble-chart-fill",
      keyIndex: 4,
    },
  ];
  return (
    <div className="multiple-content-scroll">
      <div className="scroll-block">
        <Slider {...settings}>
          {ScrollCards.map((item, index) => {
            const cls = classNames({
              "scroll-block-card": true,
              checked: index === currentIndex,
            });
            return (
              <div>
                <div className={cls}>
                  <div className="scroll-icon">
                    <i className={`icon authing-icon ${item.icon}`}></i>
                  </div>
                  <div className="text-warp">
                    <div className="name">{item.name}</div>
                    <div className="descript">{item.descript}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};
